export { ValidationRule, ValidationRuleData };

type ValidationRuleData = {
  uuid?: string;
  label: string;
  regex: string;
  errorMessage: string;
  /**
   * Set by Accelerator react FE to track which regex are valid. Assumed valid by default s
   */
  _valid?: boolean;
};
class ValidationRule {
  uuid?: string;
  label: string;
  regex: string;
  errorMessage: string;
  _valid: boolean;

  constructor(data: ValidationRuleData) {
    this.uuid = data.uuid;
    this.label = data.label ?? "";
    this.regex = data.regex;
    this.errorMessage = data.errorMessage ?? "";
    if (data._valid != undefined) {
      this._valid = data._valid;
    } else {
      this._valid = true;
    }
  }

  isConfigured(): boolean {
    return this.regex.trim().length > 0 && this._valid;
  }

  /**
   * TODO: determine the uniqueness of this method.
   */
  getRuleId(): string {
    return ValidationRule.getRuleId(this);
  }

  static getRuleId(rule: ValidationRuleData): string {
    return `${rule.uuid}-${rule.label}-${rule.errorMessage}-${rule.regex}`;
  }

  toData(): ValidationRuleData {
    return {
      uuid: this.uuid,
      label: this.label,
      errorMessage: this.errorMessage,
      regex: this.regex,
      _valid: this._valid,
    };
  }

  static createTest(rest: Partial<ValidationRuleData> = {}): ValidationRule {
    const data: ValidationRuleData = {
      uuid: "",
      label: "",
      errorMessage: "",
      regex: "",
    };

    return new ValidationRule({
      ...data,
      ...rest,
    });
  }
}
